import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';
import {toast} from 'react-toastify'

const ClinicOverviewForm = ({clinicinfo, getClinicData}) => {
    const {register, handleSubmit, formState: {errors}} = useForm(
        {
            defaultValues: clinicinfo
        }
    );
    const [clinic, setClinic] = useState(clinicinfo);
    const [isLoading, setIsLoading] = useState(false);
    const [showOverview, setShowOverview] = useState(false);

    useEffect(() => {
        setClinic(clinicinfo);
    }, [clinicinfo, getClinicData]);

    // Function to remove all non-numeric characters from phone number
    const cleanPhoneNumber = (phoneNumber) => {
        return phoneNumber.replace(/\D/g, '');
    };
    const onSubmit = (data) => {
        setIsLoading(true);
        //console.log(data);
        const newData = {
            "id": data.id,
            "name": data.name,
            "email": data.email,
            "phone": cleanPhoneNumber(data.phone),
            "sms": cleanPhoneNumber(data.sms),
            "logo": data.logo,
            "signature": data.signature,
            "website": data.website,
            "clinicType": data.clinicType,
            "street": data.street,
            "city": data.city,
            "postalCode": data.postalCode,
            "province": data.province,
            "country": data.country,
        }
        clinicService.updateClinic(clinic.id, newData)
            .then(res => {
                setIsLoading(false);
                toast.success("Modified Successfully", {
                    position: toast.POSITION.BOTTOM_RIGHT
                })
                getClinicData()
            })
            .catch(err => {
                setIsLoading(false);
                toast.error(err.response.data.message, {
                    position: toast.POSITION.BOTTOM_RIGHT
                })

            });
    };
    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row mb-2">
                    <div className="p-2"></div>
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>Type:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <select
                            className="form-select"
                            {...register("clinicType", {required: true})}
                        >
                            <option value="EYECONX">EYECONX</option>
                            <option value="SMS_GATEWAY">SMS GATEWAY</option>
                            <option value="ADMIN">ADMIN</option>
                        </select>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>Name:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Clinic Name"
                            {...register("name", {required: true})}
                        />
                        {errors.name && <div className="text-danger">Name is required</div>}
                    </div>

                </div>
                <div className="row mb-2">
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>Email:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Clinic Email"
                            {...register("email", {required: true})}
                        />
                        {errors.email && <div className="text-danger">Email is required</div>}
                    </div>


                </div>
                <div className="row mb-2">
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>Phone:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Clinic Phone"
                            {...register("phone", {required: true})}
                        />
                        {errors.phone && <div className="text-danger">Phone is required</div>}
                    </div>

                </div>
                <div className="row mb-2">
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>SMS:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Clinic SMS"
                            {...register("sms", {required: true})}
                        />
                        {errors.sms && <div className="text-danger">SMS is required</div>}
                    </div>

                </div>
                <div className="row mb-2">
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>Signature:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Clinic Signature"
                            {...register("signature", {required: true})}
                        />
                        {errors.signature && <div className="text-danger">Signature is required</div>}
                    </div>

                </div>
                <div className="row mb-2">
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>Logo:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Clinic Logo"
                            {...register("logo")}
                        />

                    </div>

                </div>
                <div className="row mb-2">
                    <div className="col-lg-3 col-md-4 label"
                         style={{fontWeight: "600", color: "rgba(1, 41, 112, 0.6)"}}>Website:
                    </div>
                    <div className="col-lg-9 col-md-8">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Clinic Website"
                            {...register("website", {required: true})}
                        />
                        {errors.website && <div className="text-danger">Website is required</div>}
                    </div>

                </div>

                <button type="submit" className="btn btn-success btn-sm">
                    {isLoading ? <span className="spinner-border spinner-border-sm" role="status"
                                       aria-hidden="true"> </span> : ""}
                    <i className="bi bi-floppy"></i> Save
                </button>

                <div className="row mb-2 break">
                </div>
            </form>
        </>
    );
}

export default ClinicOverviewForm;